import { getColumnLabel as getColumnDefLabel } from '../../data_table/columnLayout';

// Shared pieces of the Watchlist grid's column definitions. Columns are
// native TanStack Table column defs; what TanStack has no slot for lives on
// `columnDef.meta` (see WatchlistGrid). Sort functions live in
// data_table/sorting.js.

/**
 * A column's plain-text name, for menus and the Manage columns panel: its
 * string `header`, else `meta.label` (for a header that renders custom
 * content), else its id.
 */
export function getColumnLabel(column) {
    return getColumnDefLabel(column.columnDef, column.id);
}

/**
 * The text a cell shows when its column has no `cell`, and what copy and fill
 * read: `meta.formatText(value, row)`, else the value. Null when empty.
 */
export function getCellText(column, row) {
    const value = row.getValue(column.id);
    const formatText = column.columnDef.meta?.formatText;
    const text = formatText ? formatText(value, row.original) : value;
    return text == null ? null : String(text);
}

/** The `cell` of columns that define none: their text. */
export function renderTextCell({ column, row }) {
    return getCellText(column, row);
}
